var map = {
	"./br/PT/S1/gm5.png": 28457,
	"./in/EN/S1/gm5.png": 62321,
	"./ph/EN/S1/gm5.png": 10425,
	"./vn/VI/S1/gm5.png": 34074
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 84631;